import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe only in production and only if we have a key
export const stripe = import.meta.env.PROD && import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
  ? loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY)
  : Promise.resolve(null);

interface CheckoutResponse {
  sessionId?: string;
  error?: Error;
}

export async function createSubscriptionCheckout(
  priceId: string,
  customerId?: string
): Promise<CheckoutResponse> {
  // In development, simulate a successful checkout
  if (import.meta.env.DEV) {
    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    return {
      sessionId: 'dev-session-' + Date.now()
    };
  }

  // In production, use actual Stripe checkout
  try {
    const response = await fetch('/.netlify/functions/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        priceId,
        customerId,
        successUrl: `${window.location.origin}/subscription/success`,
        cancelUrl: `${window.location.origin}/subscription/cancel`,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to create checkout session');
    }

    const data = await response.json();
    return { sessionId: data.sessionId };
  } catch (error) {
    console.error('Error creating checkout session:', error);
    return { error: error as Error };
  }
}